import React from 'react'
import { FormattedMessage } from 'react-intl'

import { Container } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import makeStyles from '@material-ui/styles/makeStyles/makeStyles'
import FacebookIcon from '@material-ui/icons/Facebook'
import TwitterIcon from '@material-ui/icons/Twitter'
import InstagramIcon from '@material-ui/icons/Instagram'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import { useHistory } from 'react-router-dom'
import EVENTS from '../constants/events'
import { resetFilters } from '../constants/filters'
import useCategories from '../hooks/useCategories'
import trackEvent from '../lib/trackEvent'
import { SET_SEARCH_KEYWORD_SELECTED } from '../reducers/searchLawyer'

import { dispatch, useGlobalState } from '../store'
import Logo from './Logo'
import LAYOUT from '../constants/layout'

const useStyles = makeStyles((themeMui) => ({
  root: ({ theme }) => ({
    alignItems: 'baseline',
    color: theme.colors.textFooter || '#ffffff',
    background: theme.colors.backgroundFooter || '#c5243c',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    width: '100%',
    paddingTop: 24,
    paddingBottom: 24,
  }),
  centerVerticaly: {
    display: 'flex',
    alignItems: 'center',
  },
  centerVerticalyLogo: {
    display: 'flex',
    alignItems: 'center',

    [themeMui.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  title: {
    fontWeight: 'bold',
    marginBottom: 4,
  },
  item: ({ theme }) => ({
    color: theme.colors.textFooter || '#ffffff',
    textDecoration: 'none',
    paddingTop: 6,
  }),
  socialBlock: ({ theme }) => ({
    '& a': {
      color: theme.colors.textFooter || '#ffffff',
      textDecoration: 'none',
      marginRight: 16,
    },
  }),
}))

const Footer = () => {
  const [theme] = useGlobalState('theme')
  const classes = useStyles({ theme })
  const history = useHistory()

  const { categories } = useCategories()

  const getSizeForOneColumn = () => {
    let nbColumn = 1 // One column by default
    if (theme.allowProfile.b2c) nbColumn += 1
    if (theme.allowProfile.b2b) nbColumn += 1

    return 12 / nbColumn
  }

  const linksPro = [
    {
      name: <FormattedMessage id={'Footer.Pro1'} defaultMessage={'Droit commercial - sociétés'} />,
      href: '/recherche/droit-commercial-societes',
      domainId: 'vDMzeXAyhL2t9ExBC',
    },
    {
      name: <FormattedMessage id={'Footer.Pro2'} defaultMessage={'Droit fiscal des affaires'} />,
      href: '/recherche/droit-fiscal-des-affaires',
      domainId: 't8FP84m73zgAiAkfz',
    },
    {
      name: <FormattedMessage id={'Footer.Pro3'} defaultMessage={'Propriété intellectuelle'} />,
      href: '/recherche/propriete-intelectuelle',
      domainId: '7HgRZng9F9W4mhSmM',
    },
    {
      name: <FormattedMessage id={'Footer.Pro4'} defaultMessage={'Données personnelles'} />,
      href: '/recherche/donnees-personnelles',
      domainId: '9LbH9uGrJFaQKGGDH',
    },
    {
      name: <FormattedMessage id={'Footer.Pro5'} defaultMessage={'Contentieux des affaires'} />,
      href: '/recherche/contentieux-des-affaires',
      domainId: 'tfE36GP3prw9rgSLg',
    },
    {
      name: <FormattedMessage id={'Footer.Pro6'} defaultMessage={'Droit de la concurrence'} />,
      href: '/recherche/droit-de-la-concurence',
      domainId: 'm5vkcpdsdDNAiwujb',
    },
    {
      name: <FormattedMessage id={'Footer.Pro7'} defaultMessage={'Procédure collective'} />,
      href: '/recherche/procedure-collective',
      domainId: 'DYNrFEtmAekAF6oEi',
    },
    {
      name: <FormattedMessage id={'Footer.Pro8'} defaultMessage={'Droit pénal des affaires'} />,
      href: '/recherche/droit-penal-des-affaire',
      domainId: 'kQz7cnspN86nmBiAd',
    },
    {
      name: (
        <FormattedMessage
          id={'Footer.Pro9'}
          defaultMessage={'Informatique - Nouvelles technologies'}
        />
      ),
      href: '/recherche/informatique-nouvelles-technologies',
      domainId: 'M4ZEQ7aLHMDpdWKGL',
    },
  ]

  const linksPart = [
    {
      name: <FormattedMessage id={'Footer.Part1'} defaultMessage={'Droit social - travail'} />,
      href: '/recherche/droit-social-travail',
      domainId: 'R4nczktLiTEiGMD4a',
    },
    {
      name: (
        <FormattedMessage
          id={'Footer.Part2'}
          defaultMessage={'Droit des personnes et de la famille'}
        />
      ),
      href: '/recherche/droit-des-personnes-et-de-la-famille',
      domainId: 'mSXBq8E4vAWB8tJbZ',
    },
    {
      name: <FormattedMessage id={'Footer.Part3'} defaultMessage={'Droit pénal'} />,
      href: '/recherche/droit-penal',
      domainId: 'kBJNN7P6nwDYqJTwi',
    },
    {
      name: <FormattedMessage id={'Footer.Part4'} defaultMessage={'Droit routier'} />,
      href: '/recherche/droit-routier',
      domainId: 'ndxdTNgRE5SpXoH9T',
    },
    {
      name: <FormattedMessage id={'Footer.Part5'} defaultMessage={'Droit de la consommation'} />,
      href: '/recherche/droit-de-la-consommation',
      domainId: 'YHZBoGcQ3vz5gT3xp',
    },
    {
      name: (
        <FormattedMessage
          id={'Footer.Part6'}
          defaultMessage={'Assurance santé - dommages corporels'}
        />
      ),
      href: '/recherche/assurance-sante-dommages-corporels',
      domainId: 'XK42yy5C924kAHKoK',
    },
    {
      name: <FormattedMessage id={'Footer.Part7'} defaultMessage={'Droit immobilier'} />,
      href: '/recherche/droit-immobilier',
      domainId: 'osDyH5T3nRzRMfwwB',
    },
    {
      name: <FormattedMessage id={'Footer.Part8'} defaultMessage={'Fiscalité des particuliers'} />,
      href: '/recherche/fiscalite-des-particuliers',
      domainId: 'Dex7CWDFGYAcG4cta',
    },
    {
      name: (
        <FormattedMessage
          id={'Footer.Part9'}
          defaultMessage={'Droit des médias et de la communication'}
        />
      ),
      href: '/recherche/droit-des-medias-et-de-la-communication',
      domainId: 'sz3PNmpNWSLjqRuJg',
    },
    {
      name: <FormattedMessage id={'Footer.Part10'} defaultMessage={'Droit des étrangers'} />,
      href: '/recherche/droit-des-etranger',
      domainId: 'E3SyjEbyvzA9fouGL',
    },
    {
      name: <FormattedMessage id={'Footer.Part11'} defaultMessage={'Droit public'} />,
      href: '/recherche/droit-public',
      domainId: 'xXMfGjdEJArLD6CLW',
    },
  ]

  const handleClick = (_domainId, href) => async () => {
    if (_domainId) {
      trackEvent(EVENTS.SEARCH.RUN, _domainId)

      const category = categories.find((c) => c._id === _domainId)

      resetFilters()

      await dispatch({
        type: SET_SEARCH_KEYWORD_SELECTED,
        payload: { ...category, type: 'category' },
      })

      history.push(`/result-lawyer`)
    } else {
      window.open(href)
    }
  }

  const displayLinks = ({ href, link, name, domainId }, inline = false) => {
    return (
      <span
        key={href + link + name}
        className={classes.item}
        style={{ display: inline === true ? 'inline-block' : 'block', cursor: 'pointer' }}
        onClick={handleClick(domainId, href || link)}
      >
        {name} {inline === true ? '  •   ' : ''}
      </span>
    )
  }

  return (
    <div className={classes.root}>
      <Container maxWidth={LAYOUT.maxWidth}>
        <Grid container>
          <Grid item xs={12} sm={8}>
            <div className={classes.centerVerticalyLogo}>
              <Logo variant={'secondary'} height={53} />

              <div style={{ marginLeft: 16 }}>
                <FormattedMessage
                  id={'Footer.Copyright'}
                  defaultMessage={'Copyright © 2021 Call A Lawyer, tous droit réservés'}
                />
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div className={classes.centerVerticaly} style={{ justifyContent: 'flex-end' }}>
              <a href={theme.linkApp.ios} target={'_blank'}>
                <img alt="Disponible sur AppStore" src="/assets/store/apple/fr.svg" />
              </a>
              <a href={theme.linkApp.android} target={'_blank'}>
                <img
                  height={60}
                  alt="Disponible sur Google Play"
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/fr_badge_web_generic.png"
                />
              </a>
            </div>
          </Grid>
        </Grid>

        <br />
        <br />

        <Grid container spacing={4}>
          <Grid item xs={12} sm={getSizeForOneColumn()}>
            <div className={classes.title}>
              <FormattedMessage
                id={'Footer.About'}
                defaultMessage={'A propos de {name}'}
                values={{ name: theme.title }}
              />
            </div>

            {(theme.linkFooterAbout || []).map(displayLinks)}
          </Grid>

          {theme.allowProfile.b2b && (
            <Grid item xs={12} sm={getSizeForOneColumn()}>
              <div className={classes.title}>
                <FormattedMessage
                  id={'Footer.FindLawyerPro'}
                  defaultMessage={'Trouvez votre avocat (Entreprise)'}
                />
              </div>
              {linksPro.map(displayLinks)}
            </Grid>
          )}

          {theme.allowProfile.b2c && (
            <Grid item xs={12} sm={getSizeForOneColumn()}>
              <div className={classes.title}>
                <FormattedMessage
                  id={'Footer.FindLawyerPart'}
                  defaultMessage={'Trouvez votre avocat (Particulier)'}
                />
              </div>
              {linksPart.map(displayLinks)}
            </Grid>
          )}
        </Grid>

        <br />

        <div className={classes.socialBlock}>
          <a href={'https://www.facebook.com/callalawyer/'} target={'_blank'}>
            <FacebookIcon />
          </a>

          <a href={'https://twitter.com/getcallalawyer/'} target={'_blank'}>
            <TwitterIcon />
          </a>

          <a href={'https://www.instagram.com/call.a.lawyer/'} target={'_blank'}>
            <InstagramIcon />
          </a>

          <a href={'https://www.linkedin.com/company/18042452/'} target={'_blank'}>
            <LinkedInIcon />
          </a>
        </div>

        <br />

        <div>
          <div>Call A Lawyer, 38 rue de Liège, 75008 Paris</div>
          <div>{(theme.linkFooterLine1 || []).map((i) => displayLinks(i, true))}</div>
          <div>{(theme.linkFooterLine2 || []).map((i) => displayLinks(i, true))}</div>
        </div>
      </Container>
    </div>
  )
}

export default Footer
